import { NeoModel, ValueObject } from '@singularsystems/neo-core'

@NeoModel
export default class AccountStatusFilter extends ValueObject {
    public accountStatusName: string = ""

    public accountStatusId: number = 0
} 